<script lang="ts" setup>
import { computed } from "vue";
import { useFilters } from "@/composables";
import { useI18n } from "vue-i18n";

const { miles } = useFilters();
const { t } = useI18n();

const props = defineProps<{
  pickUpDistance: number | null;
}>();

const emptyMiles = computed(() => {
  return props.pickUpDistance !== null
    ? `${miles(props.pickUpDistance, 0)} ${t("general.empty-miles")}`
    : t("general.not-calculated-yet");
});
</script>

<template>
  <v-chip class="bg-indigo-lighten-4 text-grey-darken-3" density="comfortable" size="small">
    {{ emptyMiles }}
  </v-chip>
</template>
